'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = require('./utils');

var fadeInLeftBig = {
  from: {
    opacity: 0,
    transform: (0, _utils.translate3d)('-2000px', 0, 0)
  },
  to: {
    opacity: 1,
    transform: 'none'
  }
};
exports.default = fadeInLeftBig;


//////////////////
// WEBPACK FOOTER
// ./~/react-animations/lib/fade-in-left-big.js
// module id = 211
// module chunks = 54990529738226 257444579329143